import { store } from "../../store";

export default {
	install(app, options) {
		app.config.globalProperties.$DefModal = {
			show(payload) {
				store.commit('global/modalShow', payload);
				// document.body.style.overflow = 'hidden';
			},
			hide() {
				store.commit('global/modalHide');
				// document.body.style.overflow = 'visible';
				// console.log(12312);
			}
		}
	}
}